import styled from 'styled-components';

export const MsgWrapper = styled.section(
  props => `
    background:#fef8e5;
    border-radius:0.4rem;
    padding: 1.2rem;
    display: felx;
    flex-direction: row;
    align-items: center;
    margin-top: 1rem;
  `,
);

export const MsgTxt = styled.span`
  color: #ff3a5c;
  font-size: 1.4rem;
  padding-left: 1rem;
`;
